import { render, staticRenderFns } from "./UserManagementCapacity.vue?vue&type=template&id=0c1bc39a&"
import script from "./UserManagementCapacity.vue?vue&type=script&lang=js&"
export * from "./UserManagementCapacity.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementCapacity.vue?vue&type=style&index=0&id=0c1bc39a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports